import React, { Component } from 'react';
// import Tarjetas from "./tarjetas";
// import scrollToComponent from "react-scroll-to-component";
import { Image, Row, Col, Button } from 'react-bootstrap';
import NotFound from '../../components/notFound';

var json = {
  tesis: {
    desc:
      'El objetivo de este curso-taller es desarrollar estrategias efectivas para lograr un proceso de investigación que permita realizar y concluir exitosamente su tesis. En este curso-taller se abordarán contenidos que responden a los cuestionamientos que generalmente frenan e impiden el desarrollo de una tesis: ¿cómo logro plantear y justificar un problema de investigación?, ¿para qué sirve y cómo se construye un marco teórico?, ¿en cuáles tipos de investigación es más efectivo utilizar métodos estadísticos?, ¿cuáles problemas de investigación requieren de métodos cualitativos? o, ¿cómo se describen e interpretan los resultados de una investigación?<br/><br/>Dirigido a  egresados (pasantes) de licenciatura, maestría y doctorado que tengan como requisito la presentación de una tesis para obtener su título o grado. En todos los casos pueden participar egresados de todas las áreas.',
    titulo: 'Taller de Estrategias Efectivas para la Investigación  y  la Conclusión de Tesis',
    profe: 'Alma Gutiérrez',
    tiempo: 16,
    precio: 1850,
    img: require('./../../img/curIndTesis.png'),
  },
  equipos: {
    desc:
      'El objetivo de este curso-taller es desarrollar competencias para la integración de equipos de alto rendimiento y comunidades colaborativas que elaboren y produzcan procesos de investigación cuantitativa y cualitativa en entornos específicos. Este curso-taller pretende responder a las interrogantes siguientes: ¿Cómo se constituye un equipo de investigadores que funcione efectiva y eficientemente?, ¿cómo se logra la incorporación al Sistema Nacional de Investigadores?, ¿cómo se puede sostener y ascender en el Sistema Nacional de Investigadores?, ¿cómo acceder a los presupuestos federales, estatales, locales e internacionales para financiar la investigación?<br/><br/>Dirigido a empresarios, directores de centros de investigación, directivos de instituciones educativas, académicos, y miembros de centros de investigación.',
    titulo: 'Equipos Colaborativos para la Investigación Basados en Competencias',
    profe: 'Alma Gutiérrez',
    tiempo: 16,
    precio: 1850,
    img: require('./../../img/curIndEquipos.png'),
  },
  formacion: {
    desc:
      'Este curso-taller tiene como objetivo dotar al participante de las competencias requeridas para plantear un problema de investigación factible de llevar a cabo de manera exitosa, a través de metodologías cuantitativas y/o cualitativas.  En este curso se responde a los cuestionamientos siguientes: ¿Cuáles son las competencias básicas que debe dominar un investigador?, ¿cuáles son las competencias para plantear un problema?, ¿cuáles son las competencias que requiere un investigador para plantear un marco teórico?, ¿cuáles son las competencias que se requieren para realizar el análisis e interpretación de datos?',
    titulo: 'Taller de Metodología de Investigación Basado en Competencias',
    profe: 'Alma Gutiérrez',
    tiempo: 16,
    precio: 1850,
    img: require('./../../img/curIndFormacion.png'),
  },
  redaccion: {
    desc:
      'El objetivo de este curso es dotar a los participantes de recursos gramaticales y ortográficos que les permitan desarrollar habilidades para la comunicación escrita a través de medios impresos y electrónicos, a fin de estructurar una redacción clara, precisa y que cumpla con los objetivos planteados. Este modelo de redacción permite al participante desarrollar la competencia de redactar eficientemente, sin errores ortográficos.<br/><br/>En este curso se responde a los cuestionamientos siguientes: ¿cómo construir mensajes efectivos con una estructura gramatical adecuada que permita la comprensión del mensaje?, ¿cómo debo redactar para que mis mensajes sean efectivos?, ¿cómo evito los errores de ortografía, acentuación y puntuación?<br/><br/>Dirigido a personas que han identificado que su redacción presenta áreas de oportunidad y que desean que su comunicación escrita refleje una imagen profesional.',
    titulo: 'Redacción infalible para diversos medios y usuarios',
    profe: 'Alma Gutiérrez',
    tiempo: 16,
    precio: 1850,
    img: require('./../../img/curIndiRedaccion.png'),
  },
  metodos: {
    desc:
      'El objetivo es asegurar una aproximación hacia esta técnica, a fin de que el participante evalúe la posibilidad de trasladar el método a su propia área disciplinar. Se experimenta el rol de participante dentro de un equipo y en sesiones plenarias de discusión.<br/><br/>Un segundo nivel lo constituye el curso de Moderación de Casos en el que se organiza la experiencia de cada participante como moderador de la discusión, a fin de que sea capaz de elaborar y organizar su tiempo y contenidos en una “Nota Técnica” (teaching note) haciendo énfasis en la generación de instrumentos que permitan al participante evaluar la efectividad del aprendizaje de los alumnos. Los casos que se trabajas en estos cursos se obtienen de base de datos internacionales, nacionales o bien casos escritos por los autores/instructores.<br/><br/>En un tercer nivel de la técnica Redacción de Casos es que el participante adquiera una estructura básica para la redacción de casos. Para ello se identifican las fases primordiales para investigar, sistematizar y organizar la información que registra a partir de un problema de una realidad concreta, sea este hecho educacional, laboral, empresarial, social o familiar.<br/><br/>Dirigido a profesores de nivel medio superior y superior (licenciatura y posgrado).',
    titulo: 'El método de casos como estrategia didáctica: redacción y moderación',
    profe: 'Alma Gutiérrez',
    tiempo: 16,
    precio: 1850,
    img: require('./../../img/curIndMetodos.png'),
  },
};

export default class nameClass extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.routeParam = this.props.match.params;
  }
  componentWillMount() {}
  render() {
    if (!json[this.routeParam.nombre]) return <NotFound />;
    return (
      <div className="navMargin" style={{ height: '100%' }}>
        <section
          style={{
            paddingTop: '2%',
            backgroundColor: '#352a35',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="container">
            <Row>
              <Col
                xs={12}
                md={5}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Image
                  src={json[this.routeParam.nombre].img}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  responsive
                />
                <div style={{ height: 50 }} />
                <Button
                  bsClass="btn compraBtn"
                  target="_blank"
                  href={`mailto:editorialtyr@gmail.com?Subject=Inscribirme%20a%20${
                    json[this.routeParam.nombre].titulo
                  }`}
                >
                  Inscribirse
                </Button>
                {/* <p style={{ color: "#e4e400", fontSize: "16pt" }}>
                  Costo: $ {parseFloat(json[this.routeParam.nombre].precio).toFixed(2)}
                </p> */}
              </Col>
              <Col xs={12} md={7}>
                <p
                  style={{
                    color: 'white',
                    fontSize: '18pt',
                    fontWeight: 'bold',
                  }}
                >
                  {json[this.routeParam.nombre].titulo}
                </p>
                {/* <p style={{ color: "#929292", fontSize: "16pt" }}>
                  Impartido por: {json[this.routeParam.nombre].profe}
                </p> */}
                {/* <p style={{ color: "#929292", fontSize: "16pt" }}>
                  Duración: {json[this.routeParam.nombre].tiempo} horas
                </p>
                <p
                  style={{
                    color: "white",
                    fontSize: "16pt",
                    fontWeight: "bold"
                  }}
                >
                  Descripción del Curso
                </p> */}
                <p
                  style={{ color: 'white', fontSize: '14pt' }}
                  dangerouslySetInnerHTML={{ __html: json[this.routeParam.nombre].desc }}
                />
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/cursos/showCursos.js